export const isValidEmailSyntax = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@\.]{2,18}$/

  return emailRegex.test(email)
}
